module.exports = __webpack_public_path__ + "img/ic_favorite_off.a3f20dd3.svg";